@for (optionGroup of showcaseOptionGroups; track trackOptionGroup(index, optionGroup); let index = $index) {
    <ms-showcase-option-group [model]="optionGroup" [event]="event" [tracking]="tracking" [viewType]="viewType" />
}
